import { render, staticRenderFns } from "./NguoiDungTcqlttList.vue?vue&type=template&id=f031faaa&"
import script from "./NguoiDungTcqlttList.vue?vue&type=script&lang=js&"
export * from "./NguoiDungTcqlttList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports